import axios from 'axios';
import cn from 'classnames';
import { Form, Link, useActionData, useLoaderData } from 'react-router-dom';

import Logo from 'jsx:../img/tandem-logo-horizontal.svg';
import isEmpty from 'lodash.isempty';
import Alert from '../components/Alert';

export async function resetPasswordLoader({ request }) {
	const url = new URL(request.url);
	const vCode = url.searchParams.get('vcode');
	return { vCode };
}

export async function resetPasswordAction({ request /*params */ }) {
	const formData = await request.formData();
	const data = Object.fromEntries(formData);
	const errors = {};
	if (isEmpty(data?.email)) {
		errors.email = 'Email address is required';
	}
	if (isEmpty(data?.vCode)) {
		errors.vCode = 'Verification code is required';
	}
	if (isEmpty(data?.password1)) {
		errors.password1 = 'Password is required';
	}
	if (isEmpty(data?.password2)) {
		errors.password2 = 'Password is required';
	}
	if (data.password1 !== data.password2) {
		errors.password = 'Password fields do not match';
	}

	if (isEmpty(errors)) {
		try {
			await axios.post('/coords/reset_user_password', {
				access_code: data.vCode,
				email: data.email,
				password: data.password1,
			});
			return { submitted: true };
		} catch (err) {
			errors.error =
				'There was a problem resetting your password. Please try again.';
		}
	}

	return { errors };
}

const ResetPassword = () => {
	const loaderData = useLoaderData();
	const actionData = useActionData();

	// console.log(loaderData, actionData);
	return (
		<div className="flex flex-col flex-1 min-h-full px-6 pt-16 lg:px-8">
			<div className="sm:mx-auto sm:w-full sm:max-w-sm">
				<div className="w-full h-auto">
					<Logo />
				</div>
				{actionData?.submitted ? (
					<>
						<h1 className="mt-6 leading-9 tracking-tight text-center text-gray-900">
							Password reset successfully
						</h1>
						<p className="text-center">
							Log into your account with your new password.
						</p>
					</>
				) : (
					<h1 className="mt-6 leading-9 tracking-tight text-center text-gray-900">
						Sign in to your account
					</h1>
				)}
			</div>

			<div className="mt-10 sm:mx-auto sm:w-full sm:max-w-sm">
				{actionData?.submitted ? (
					<Link to="/" className="btn btn-primary btn-block">
						Log in
					</Link>
				) : (
					<Form className="space-y-6" method="POST">
						{!!actionData?.errors?.error && (
							<Alert message={actionData.errors.error} />
						)}
						<div className="form-control">
							<label htmlFor="email" className="label label-text">
								Email address
							</label>
							<input
								id="email"
								name="email"
								type="email"
								autoComplete="email"
								required
								className={cn('input', 'input-bordered', {
									'input-error': !!actionData?.errors?.email,
								})}
								aria-invalid={!!actionData?.errors?.email}
							/>
							{!!actionData?.errors?.email && (
								<p className="text-error">{actionData.errors.email}</p>
							)}
						</div>

						<div className="form-control">
							<label htmlFor="v-code" className="label label-text">
								Verification code
							</label>
							<input
								id="v-code"
								name="vCode"
								type="text"
								maxLength={6}
								minLength={6}
								autoComplete="one-time-code"
								defaultValue={loaderData?.vCode}
								required
								className={cn('input', 'input-bordered', {
									'input-error': !!actionData?.errors?.vCode,
								})}
								aria-invalid={!!actionData?.errors?.vCode}
							/>
							{!!actionData?.errors?.vCode && (
								<p className="text-error">{actionData.errors.vCode}</p>
							)}
						</div>

						<div className="form-control">
							<label htmlFor="new-password" className="label label-text">
								New Password
							</label>
							<input
								id="new-password"
								name="password1"
								type="password"
								autoComplete="new-password"
								minLength={8}
								required
								className={cn('input', 'input-bordered', {
									'input-error':
										!!actionData?.errors?.password ||
										!!actionData?.errors?.password1,
								})}
								aria-invalid={
									!!actionData?.errors?.password ||
									!!actionData?.errors?.password1
								}
							/>
							{!!actionData?.errors?.password && (
								<p className="text-error">{actionData.errors.password}</p>
							)}
							{!!actionData?.errors?.password1 && (
								<p className="text-error">{actionData.errors.password1}</p>
							)}
						</div>

						<div className="form-control">
							<label htmlFor="confirm-password" className="label label-text">
								Confirm Password
							</label>
							<input
								id="confirm-password"
								name="password2"
								type="password"
								autoComplete="new-password"
								minLength={8}
								required
								className={cn('input', 'input-bordered', {
									'input-error':
										!!actionData?.errors?.password ||
										!!actionData?.errors?.password2,
								})}
								aria-invalid={
									!!actionData?.errors?.password ||
									!!actionData?.errors?.password2
								}
							/>
							{!!actionData?.errors?.password && (
								<p className="text-error">{actionData.errors.password}</p>
							)}
							{!!actionData?.errors?.password2 && (
								<p className="text-error">{actionData.errors.password2}</p>
							)}
						</div>

						<div>
							<button type="submit" className="btn btn-primary btn-block">
								Reset Password
							</button>
						</div>

						<div>
							<Link to="/" className="btn btn-outline btn-block btn-sm">
								Return to Login
							</Link>
						</div>
					</Form>
				)}
			</div>
		</div>
	);
};

export default ResetPassword;
